document.addEventListener('DOMContentLoaded', () => {
  const tabTitle = document.querySelectorAll('div[data-its-tab-title]');
  const tabText = document.querySelectorAll('div[data-its-tab-text]');
  const container = document.querySelector('.description-accordion');
console.log("accordion loaded");
  if (!container || !tabTitle.length) return;

  tabTitle.forEach((title, i) => {
    const textHtml = tabText[i] ? tabText[i].innerHTML : '';

    container.insertAdjacentHTML(
      'beforeend',
      `
      <div class="product__accordion accordion quick-add-hidden">
        <details id="Details--js${i}">
          <summary class="js-added" role="button" aria-expanded="false" aria-controls="ProductAccordion--js${i}">
            <div class="summary__title">
              <h2 class="h4 accordion__title inline-richtext">
                ${title.innerHTML}
              </h2>
            </div>
            <div class="accordion-toggle">
              <span class="toggle-closed"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
              </svg></span>
              <span class="toggle-open"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
              </svg></span>
            </div>
          </summary>
          <div class="accordion__content rte" id="ProductAccordion--js${i}">
            <div class="product__description rte quick-add-hidden">
              ${textHtml}
            </div>
          </div>
        </details>
      </div>
      `
    );
  });
});
